module.exports = {

    public:'Public',
    module:'Module',
    scription:'Notification Subscription',
    helpcenter:'Help center',
    resource:'Resource',
    task:'Task Reminder',
    productUpdate:'Product Update',
    contract:'Contract expiry reminder',
    invoice:'Invoice reminder',
    week:'Once a week',
    month:'Once a month',
    day:'Once a day',
    report:'Report',
    creative:'Creative',
    closing:'Closing Report',
    analysis:'Analysis Report',
    fixsuccess:'Edit success',
    fixfail:'Edit fail',
    Notopen:'Not open',
    ServiceTeam:'Service Team',
    koltrack:'KOL Tracking'

}


// WEBPACK FOOTER //
// ./src/i18n/modules/notificationSub/en.js